var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 1056q-137 0-233.5-96.5T170 726V366q0-38 26.5-64t63.5-26q7 0 15 1.5t15 3.5v-35q0-38 26.5-64t63.5-26q8 0 16.5 1.5T413 162q11-29 34.5-47.5T500 96q35 0 62.5 25.5T590 182q5-2 13-4t17-2q38 0 64 26t26 64v164q8-2 16.5-3t13.5-1q38 0 64 26t26 64v210q0 137-96.5 233.5T500 1056Zm0-60q56 0 105.5-21t86-57.5q36.5-36.5 57.5-86T770 726V516q0-13-8.5-21.5T740 486q-12 0-21 8.5t-9 21.5v170l-13 2q-45 7-74.5 40T590 806h-60q3-56 35.5-100t84.5-66V266q0-13-8.5-21.5T620 236q-12 0-21 8.5t-9 21.5v260h-60V186q0-13-8.5-21.5T500 156q-12 0-21 8.5t-9 21.5v340h-60V246q0-13-8.5-21.5T380 216q-12 0-21 8.5t-9 21.5v320h-60V366q0-13-8.5-21.5T260 336q-12 0-21 8.5t-9 21.5v360q0 56 21 105.5t57.5 86q36.5 36.5 86 57.5T500 996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontHand);
export default __webpack_public_path__ + "static/media/front_hand.919940754f0b3ae6226d46258427c4e4.svg";
export { ForwardRef as ReactComponent };